import endpoint from "../../../config/endpoints";
import { noInternetMsg, serverMsg } from "../../../config/messageconstant";
import { apiGet } from "../../../utils/api_service";
import { mergeOrdersWithStock } from "./advanceOutletInvoicingUtils";

const STOCK_URL = `${endpoint.manageStockHeaderLatest}/stock-by-current-date`;

const notifyError = (showNotification, msg = serverMsg) => {
  showNotification({ msg, severity: "error" });
};

const fetchStockAndMerge = async ({
  response,
  showNotification,
  setOutletOrderDetail,
  setProductStockData,
  includeStakeholderMeta,
}) => {
  const { data, success } = await apiGet({ url: STOCK_URL });

  if (!success) {
    notifyError(showNotification);
    return;
  }

  const productStocks = [...data.data.productStocks];
  const rowData = mergeOrdersWithStock(response, productStocks, {
    includeStakeholderMeta,
  });

  setProductStockData(data.data);
  setOutletOrderDetail({ row: rowData });
};

export const fetchOrdersByOutlet = async ({
  outletIds,
  fromDate,
  toDate,
  flag,
  getOutletOrderDetailUpdated,
  showLoador,
  showNotification,
  setOutletOrderDetail,
  setProductStockData,
}) => {
  if (!navigator.onLine) {
    notifyError(showNotification, noInternetMsg);
    return;
  }

  showLoador({ loador: true });
  try {
    const { response, success } = await getOutletOrderDetailUpdated({
      outletIds,
      fromDate,
      toDate,
    });

    if (!success) {
      notifyError(showNotification);
      return;
    }

    if (flag) {
      await fetchStockAndMerge({
        response,
        showNotification,
        setOutletOrderDetail,
        setProductStockData,
        includeStakeholderMeta: false,
      });
      return;
    }

    setOutletOrderDetail({ row: response });
  } finally {
    showLoador({ loador: false });
  }
};

export const fetchOrdersBySalesPerson = async ({
  salesPersonIds,
  fromDate,
  toDate,
  flag,
  getOutletOrderDetailBySalesNew,
  showLoador,
  showNotification,
  setOutletOrderDetail,
  setProductStockData,
}) => {
  if (!navigator.onLine) {
    notifyError(showNotification, noInternetMsg);
    return;
  }

  showLoador({ loador: true });
  try {
    const { response, success } = await getOutletOrderDetailBySalesNew({
      dataToPost: {
        salesTeamIds: salesPersonIds,
        fromDate,
        toDate,
      },
    });

    if (!success) {
      notifyError(showNotification);
      return;
    }

    if (flag) {
      await fetchStockAndMerge({
        response,
        showNotification,
        setOutletOrderDetail,
        setProductStockData,
        includeStakeholderMeta: true,
      });
      return;
    }

    setOutletOrderDetail({ row: response });
  } finally {
    showLoador({ loador: false });
  }
};
